import { useQuery } from "@tanstack/react-query";
import { DeliveryPerformanceMetric } from "../types";
import { programmeDashboardApi } from "../api/programmeDashboard";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

const formatPercentage = (value: number): string => {
  return `${value.toFixed(1)}%`;
};

export const useDeliveryPerformance = ({ portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["delivery-performance", portfolio_id, quickFilters],
    queryFn: () => {
      const params = {
        portfolio_id: portfolio_id,
        workstream_id: extractFilterValues(quickFilters.workstream) || null,
        site_id: extractFilterValues(quickFilters.site) || null,
        programme_id: extractFilterValues(quickFilters.programme) || null,
        region_id: extractFilterValues(quickFilters.region) || null,
        work_type_group_id: extractFilterValues(quickFilters['worktype-group']) || null,
        project_year: extractFilterValues(quickFilters.projectYear) || null,
      };
      return programmeDashboardApi.fetchDeliveryPerformance(params)
    },
  });

  const metrics: DeliveryPerformanceMetric[] = data?.data
    ? [
      {
        label: portfolio_id ? "Projects on track" : "Portfolios on track",
        value: portfolio_id ? data.data.project_on_track : data.data.portfolio_on_track,
        subValue: `out of ${data.data.total}`,
      },
      {
        label: "Projects Delayed",
        value: data.data.project_delayed,
      },
      {
        label: "Partner TCQI",
        value: formatPercentage(data.data.partner_tcqi),
      },
      {
        label: "Stage gate approval speed",
        value: `${Math.round(data.data.approval_speed)} days`,
        subValue: "avg",
      },
      {
        label: "Reg. Dates at Risk",
        value: data.data.regulatory_at_risk,
      },
      {
        label: `${portfolio_id ? "Projects" : "Portfolios"} Cost Performance Vs Allowance`,
        value: `${data.data.allowance.toFixed(3)}%`,
      },
    ]
    : [];

  return {
    metrics,
    isLoading,
    isError,
    error:
      error instanceof Error
        ? error.message
        : "Failed to fetch delivery performance",
  };

};